<template>
  <div class="setting__menu">
    <a-menu
      :selected-keys="[$route.path.substr($route.path.lastIndexOf('/'))]"
      theme="light"
      mode="inline"
      :trigger="false"
    >
      <a-menu-item
        v-for="link in links"
        :key="link.route.substr(link.route.lastIndexOf('/'))"
      >
        <router-link :to="link.route">
          <span>{{ link.title }}</span>
        </router-link>
      </a-menu-item>
    </a-menu>
  </div>
</template>

<script>
export default {
  data() {
    return {
      name: "Slidermenu",
      links: [
        { title: "块", route: "/setting/block" },
        { title: "数据", route: "/setting/data" },
        { title: "偏好", route: "/setting/predilection" }
      ]
    };
  }
};
</script>

<style>
.setting__menu {
  height: 100%;
  border-right: 1px solid #e8e8e8;
  padding: 1.2rem 0;
}
/* .ant-menu-inline,
.ant-menu-vertical,
.ant-menu-vertical-left {
  border-right: none;
} */
</style>
